module.exports = "/assets/data/bea40c9aa80bed6824875d8c32affb9a-SO19.data.json";